import { fromJS } from 'immutable';

import {
  FETCH_TASK_PROFILES_SUCCESS,
  FETCH_TASK_PROFILES_FAILED,
  FETCH_TASK_PROFILE_SUCCESS,
  FETCH_TASK_PROFILE_FAILED,
} from '../actions/taskprofiles';
import { saveTaskProfileRoutine, removeTaskProfileRoutine } from '../routines';
import { updateOrAdd } from './helper';

const initialState = fromJS({
  taskProfiles: [],
  taskProfile: {},
  loading: true,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_TASK_PROFILES_SUCCESS:
      return state.set('taskProfiles', fromJS(action.taskProfiles)).set('loading', false);
    case FETCH_TASK_PROFILES_FAILED:
      return state.set('error', action.error).set('loading', false);
    case FETCH_TASK_PROFILE_SUCCESS:
      return state.set('taskProfile', fromJS(action.taskProfile)).set('loading', false);
    case FETCH_TASK_PROFILE_FAILED:
      return state.set('error', action.error).set('loading', false);

    case saveTaskProfileRoutine.TRIGGER:
      console.log('saveTaskProfileRoutine.REQUEST', action);
      return state.updateIn(['taskProfiles'], updateOrAdd(action.payload.values));
    case removeTaskProfileRoutine.SUCCESS:
      return state.updateIn(['taskProfiles'], (taskProfiles) => {
        return taskProfiles.filter((profile) => profile.get('id') !== action.payload.request.id);
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/taskprofiles.js